import * as PIXI from 'pixi.js'
import { IPopOutSpaceData, IBouncer, Place } from 'js/bubbleCore/types';
import { BouncerView } from 'js/bubbleCore/view/entities/BouncerView';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { EventType, IEvent, IHasEventHandlers, EventHandlers } from 'js/bubbleCore/events';

export class BouncersView extends PIXI.Container implements IHasEventHandlers {
  public readonly eventHandlers: EventHandlers =  {
    [EventType.BubbleUpdated]: (e) => {
      if (e.data.bubble.place !== Place.PopOutSpace) return;
      this.idToView.forEach((b) => b.handleBubbleUpdate(e.data.bubble))
    },
  };
  private readonly model: IPopOutSpaceData;
  private readonly idToView: Map<string, BouncerView> = new Map();

  constructor(model: IPopOutSpaceData, hexPixelSize: IHexPixelSize) {
    super();
    this.model = model;

    model.bouncers.forEach((bouncer: IBouncer) => {
      const view = new BouncerView(bouncer, hexPixelSize, model.pointZones[0].rect.width * 1);
      this.addChild(view);
      this.idToView.set(bouncer.id, view);
    });
  }
}